import { _, debounce } from './../utils.js'
export default (el) => {
    const trigger = _('search').nodeFrom(el)
    const noResultsMessage = _('no-results-message', 'element').nodeFrom(el)

    const filterResults = (e) => {
        const searchValue = e.target.value.toLowerCase()
        let sectionsShowing = 0

        if (searchValue.length > 1 || searchValue.length === 0) {
            const sections = _('search-section', 'element').nodesFrom(el)

            sections.map((section) => {
                const results = _('filter-result', 'element').nodesFrom(section)
                let containsItems = 0
                results.map((result) => {
                    const containsSearchValue = result.textContent
                        .replace(/\s/g, ' ')
                        .toLowerCase()
                        .includes(searchValue)

                    if (containsSearchValue) {
                        result.classList.remove('u-hidden')
                    } else {
                        result.classList.add('u-hidden')
                    }
                    containsItems += containsSearchValue
                })
                if (containsItems) {
                    section.classList.remove('u-hidden')
                    sectionsShowing++
                } else {
                    section.classList.add('u-hidden')
                }
            })
            if (sectionsShowing) {
                noResultsMessage.classList.add('u-hidden')
            } else {
                noResultsMessage.classList.remove('u-hidden')
            }
        }
    }

    trigger.addEventListener('input', debounce(filterResults, 500))
}
